export const LOCALES = {
    RUSSIAN: 'ru-RU',
    ENGLISH: 'en-US',
    CHINESE: 'zh-CN'
}